export const SIDEBARS = ['clipboard', 'filters', 'gallery'] as const

export type FiltersFocusType = 'advanced' | 'tags'

export type SidebarType = (typeof SIDEBARS)[number]

export type SidebarsLockedType = Record<SidebarType, boolean>
